import ReactECharts from 'echarts-for-react';
import React from 'react';
import styled from 'styled-components';

import * as COLORS from '~/colors';
import { Futura } from '~/styles';

export default function ({ org, onClick }) {
  const { demographics } = org;
  const demographic = demographics[0];
  const data = demographic.values;

  const option = {
    tooltip: {
      trigger: 'item',
    },
    color: COLORS.chart,
    series: [
      {
        name: demographic.name,
        type: 'pie',
        radius: ['45%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        labelLine: {
          show: false,
        },
        data,
      },
    ],
  };

  return (
    <Wrapper>
      <Title>デモグラフィック</Title>
      <Main>
        <ReactECharts option={option} opts={{ height: '200px' }} />
      </Main>
      <SeeMore onClick={onClick}>SEE MORE</SeeMore>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 235px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Main = styled.div`
  height: 195px;
`;

const SeeMore = styled(Futura)`
  margin-left: 35px;
  padding-bottom: 10px;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
`;
